import { initState } from './index';

export default {
  reset(state) {
    Object.assign(state, initState());
  },
  setError(state, error) {
    state.error = error;
  },
  setLoading(state, payload) {
    state.isLoading = payload;
  },
  setDetail(state, payload) {
    state.detail = payload;
  },
  setRules(state, payload) {
    state.rules = payload;
  },
  setStatuses(state, payload) {
    state.statuses = payload;
  },
  setTypes(state, payload) {
    state.types = payload;
  },
};
